module.exports = __webpack_public_path__ + "static/img/bundles__img-4.b42c1917.svg";